module.exports = __webpack_public_path__ + "static/apple-icon-180x180-6406523b0e99d10327cdef81a239a949.png";